import _api from '../../coupons/_api';
import couponErrors from '../../coupons/_api/couponErrors';

import Coupon from '../../../models/Coupon';

export default {
  namespaced: true,
  // -----------------------------------------------------------------
  state: {
    actual: {},
  },
  // -----------------------------------------------------------------
  getters: {
    actual: (state,) => state.actual,
  },
  // -----------------------------------------------------------------
  mutations: {
    newCoupon: (state,) => state.actual = new Coupon(),
    setCoupon: (state, coupon,) => state.actual = new Coupon(coupon,),
    cleanCoupon: (state,) => state.actual = {},
  },
  // -----------------------------------------------------------------
  actions: {
    getCouponDetails ({ commit, }, { couponId, },) {
      commit('cleanCoupon',);
      return _api.get({ _id: couponId, },).then(
        (response,) => {
          commit('setCoupon', response.data,);
          return response.data;
        },
        (error,) => {
          return _api.handleError(error,);
        },
      );
    },
    // eslint-disable-next-line no-unused-vars
    updateCoupon: async ({ getters, }, coupon,) => {
      return new Promise((resolve, reject,) => {
        let newCoupon = new Coupon(coupon,).toPut;
        _api.
          put(newCoupon,).
          then(() => {
            resolve();
          },).
          catch((error,) => {
            const errorMessages = couponErrors(error.
              response.data.errors.map((err,) => err.slug,),);
            reject(errorMessages,);
          },);
      },);
    },
  },
};
